export function getHotelSlug(hotelTitle: string) {
  const hotel_id = hotelTitle.toLowerCase().replace(/\s/g, "-");
  const hotel_id_no_special_characters = hotel_id.replace(/[^a-zA-Z0-9-]/g, "");
  const hotel_id_no_dash_at_end = hotel_id_no_special_characters.replace(
    /-*$/,
    ""
  );
  const hotel_slug = hotel_id_no_dash_at_end.replace(/-{2,}/g, "-");
  return hotel_slug;
}
